// extracted by mini-css-extract-plugin
export default {"cls1":"AttachmentOverlay-cls1__aa383ac9eb75fbf55bce","cls2":"AttachmentOverlay-cls2___08893c940ef7aecca26 AttachmentOverlay-cls1__aa383ac9eb75fbf55bce"};